import React from 'react';
import DynamicFilterBlock from '@components/dynamic-filter-block/dynamic-filter-block';
import NoResultsFound from '@components/global-commitment/no-results-found/no-results-found';
import OrganisationNameCell from '@components/table/sub-components/organisation-name-cell';
import { useStaticQuery, graphql } from 'gatsby';
import styled from '@emotion/styled/macro';
import Table from '@components/table/table';
import TableCell from '@components/table/sub-components/table-cell';
import TableRow from '@components/table/sub-components/table-row';
import useFilter from '@hooks/use-filter';
import vars from '@variables';
import { convertStringToBoolean, generateKey } from '@utils/utils';
import { generateGCReportUrl } from '../../utils/generate-url-functions';
import { govData as tableData } from '../../data/global-commitment-report-2021/listing-page.data';
import { ListingtableProps } from './global-commitment-table.types';

const GovListingTable: React.FC<ListingtableProps> = ({ className }) => {
  const data = useStaticQuery(graphql`
    query AllGovQuery {
      gov: allGcGovDataCsv {
        nodes {
          id
          category: category__b_0
          slug: slug__b_4
          name: organisation_name__b_1
          sortableName: organisation_name_sortable__b_1_bis
          publishReport: publish_report__b_3
          type: government_type___a_2
          country: country__a_3
        }
      }
    }
  `);
  const allOrganisationData = data.gov.nodes;
  const { dynamicFilterBlockData, tableHeaderData } = tableData;
  const {
    filteredData,
    updateQueryArray,
    setCompareFunctionConfig,
  } = useFilter(allOrganisationData);

  return (
    <div className={className}>
      <DynamicFilterBlock
        updateQueryArray={updateQueryArray}
        setCompareFunctionConfig={setCompareFunctionConfig}
        elementData={dynamicFilterBlockData}
      />
      {filteredData.length > 0 ? (
        <div className="table-container">
          <Table tableHeaderData={tableHeaderData}>
            {filteredData.map((organisation, index) => {
              return (
                <TableRow
                  key={generateKey(organisation.name, index)}
                  url={
                    convertStringToBoolean(organisation.publishReport)
                      ? generateGCReportUrl(
                          organisation.category,
                          organisation.name,
                          organisation.slug
                        )
                      : null
                  }
                >
                  <OrganisationNameCell
                    name={organisation.name}
                    sector={organisation.sector}
                    tag={
                      convertStringToBoolean(organisation.isFirstYear)
                        ? {
                            text: 'first year',
                            colour: vars.plasticsBlue,
                          }
                        : null
                    }
                  />
                  <TableCell>{organisation.type}</TableCell>
                  <TableCell>{organisation.country}</TableCell>
                </TableRow>
              );
            })}
          </Table>
        </div>
      ) : (
        <NoResultsFound />
      )}
    </div>
  );
};

const StyledGovListingTable = styled(GovListingTable)`
  .table-container {
    overflow-x: auto;
    ${Table} {
      width: ${vars.contentMaxWidth};
    }
  }
`;

export default StyledGovListingTable;
